var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurClient9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 158,
    viewBox: "0 0 235 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 234,
    height: 157,
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.205 63H128.669V68.4919H117.384V94.9998H111.49V68.4919H100.205V63Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M167.823 63H161.881V94.9998H167.823V63Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M143.71 74.811H136.541L132.532 80.7165L126.843 89.0946L122.834 95H130.003L134.012 89.0946L139.701 80.7165H150.504V74.811H143.71Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M94.0761 67.6691C90.9921 64.5564 87.2527 63 82.8623 63H69V68.6768H82.678C85.471 68.6768 87.8599 69.6826 89.8384 71.6981C91.8191 73.7116 92.8073 76.1386 92.8073 78.977C92.8073 81.8155 91.817 84.2404 89.8384 86.2559C87.8578 88.2694 85.4689 89.2772 82.678 89.2772H69V94.9998H82.8623C87.2213 94.9998 90.9523 93.4372 94.0551 90.3079C97.158 87.1806 98.7073 83.403 98.7073 78.9791C98.7073 74.5552 97.1643 70.7838 94.0782 67.6711L94.0761 67.6691Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M156.448 80.7163H150.506V94.9998H156.448V80.7163Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M144.562 63L140.551 68.9054H144.562H150.504V74.8108H156.446V68.9054V63H144.562Z",
    fill: "#5F57EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurClient9);
export default __webpack_public_path__ + "static/media/our-client-9.9d3e7f697dc8df435b253402ad64ecde558e6b9f8ab3e476f11732155f9dd945.svg";
export { ForwardRef as ReactComponent };